import { commonValidations } from 'helpers'

const rules = {
  phoneNumber: [commonValidations.mobilePhone],
}

const validationHelpers = { rules }

export { validationHelpers }
